import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Section from "../layout/Section";
import Container from "../layout/Container";

/* 🔥 COUNTER */
function Counter({ end, suffix = "" }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1200;
    const stepTime = 16;
    const steps = duration / stepTime;
    const increment = end / steps;

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setValue(end);
        clearInterval(timer);
      } else {
        setValue(Math.floor(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [end]);

  return (
    <>
      {value}
      {suffix}
    </>
  );
}

export default function StatsStrip() {
  const stats = [
    { value: 1000, suffix: "+", label: "Happy Guests" },
    { value: 32, suffix: "%", label: "Revenue Growth" },
    { value: 4.8, suffix: "★", label: "Guest Rating" },
    { value: 24, suffix: "/7", label: "Guest Support" },
  ];

  return (
    <Section background="bg-bg-surface" padding="none" className="py-10 lg:py-16">
      <Container>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-10 items-center">

          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="max-w-content"
          >

            <h2 className="mt-2 lg:mt-4 text-display font-extrabold text-text-primary leading-tight">
              Proven scale across
              <span className="block text-brand-primary">
                real properties
              </span>
            </h2>

            <p className="mt-3 lg:mt-4 text-body text-text-muted max-w-reading">
              Every metric reflects real operations, not projections.
            </p>
          </motion.div>

          {/* RIGHT */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:gap-5">

            {stats.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08 }}
                className="
                  p-4 lg:p-6 rounded-2xl
                  bg-bg-surface
                  border border-border-soft
                  hover:border-brand-primary
                  transition
                "
              >
                <div className="flex items-center justify-between">

                  <div className="
                    text-[28px] font-extrabold
                    text-text-primary
                  ">
                    <Counter end={s.value} suffix={s.suffix} />
                  </div>

                </div>

                <div className="mt-2 text-small text-text-muted">
                  {s.label}
                </div>

              </motion.div>
            ))}

          </div>

        </div>

      </Container>
    </Section>
  );
}